import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Attachment } from '@interfaces';
import { groupBy } from 'lodash';
import { MaintenanceDialogData } from '../../dialog-maintenances.component';


@Component({
  selector: 'tab-attachments',
  templateUrl: './tab-attachments.component.html',
  encapsulation: ViewEncapsulation.None
})
export class TabAttachmentsComponent {
  requestAttachments: Attachment[];
  integrationAttachments: Attachment[];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: MaintenanceDialogData,
  ) {
    const grouped = groupBy(this.data.maintenance.attachments, 'type');
    this.requestAttachments = grouped['request'];
    this.integrationAttachments = grouped['integration'];
  }

}
